import { v4 as uuidv4 } from 'uuid';

export function SellerHeadCell(props = {}, childrenComponents = []) {
	return {
		componentName: 'SellerHeadCell',
		componentId: uuidv4(),
		title: '',
		props: Object.assign(
			{
				title: '',
			},
			props,
		),
		childrenComponents,
	};
}
